'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // register template renderers
    selectionTemplates['productCmsPageSelect2Template'] = productCmsPageSelect2Template;
    resultTemplates['productCmsPageSelect2Template'] = renderProductCmsPageSelect2ResultTemplate;

    // odata result rendering
    _event2.default.off('linksoft.select2.renderingTemplate', renderResult);
    _event2.default.on('linksoft.select2.renderingTemplate', renderResult);

    // selected item rendering
    _event2.default.off('linksoft.select2.renderingTemplateSelection', renderSelection);
    _event2.default.on('linksoft.select2.renderingTemplateSelection', renderSelection);

    // trigger this event to force render of the selection (this way the preselected item is updated with the custom template)
    (0, _jquery2.default)('select[data-custom-template]').trigger('change');
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _event = require('linksoft/core/event');

var _event2 = _interopRequireDefault(_event);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)('App');

var selectionTemplates = {};
var resultTemplates = {};

function renderSelection(params) {
    var customTemplate = (0, _jquery2.default)(params.item).attr('data-custom-template');

    if (customTemplate && selectionTemplates[customTemplate]) {
        params.result = selectionTemplates[customTemplate](params);
    }
}

function renderResult(params) {
    var customTemplate = (0, _jquery2.default)(params.item).attr('data-custom-template');

    if (customTemplate && resultTemplates[customTemplate]) {
        params.result = resultTemplates[customTemplate](params);
    }
}

/* begin productCmsPageSelect2Template layer */
function productCmsPageSelect2Template(params) {
    // if the value is preselected at page load, its additional information (=edition) is stored in the parent select in data-initial-value attribute
    var selectionEdition = params.data.text2 || (0, _jquery2.default)(params.item).attr('data-initial-value');
    if (selectionEdition && params.data.id !== "") {
        return renderProductCmsPageSelect2Layer(selectionEdition, params.data.text);
    }
    return params.result;
}

function renderProductCmsPageSelect2ResultTemplate(params) {
    if (params.data.text2) {
        return renderProductCmsPageSelect2Layer(params.data.text2, params.data.text);
    }
    return params.result;
}

function renderProductCmsPageSelect2Layer(edition, text) {
    var textEdition = edition === 'Gold' ? resx.App.GoldEdition : resx.App.SilverEdition;
    return '<span>' + text + ' - ' + textEdition + '</span>';
}
/*end productCmsPageSelect2Template layer */


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/select2templates.js
// module id = 452
// module chunks = 0